import { GET_BROCHURE_LIST_SUCCESS, GET_BROCHURE_SUCCESS, GET_PROPERTIES_DISCONTINUED_SUCCESS
} from "./actions";

const INIT_STATE = {
    brochure:null,
    discontinued:null,
    brochureList:null,
    totalItems:0
};

const ReportsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_BROCHURE_SUCCESS:
            return {
                ...state,
                brochure: action.payload
            };
        case GET_BROCHURE_LIST_SUCCESS:
            return {
                ...state,
                brochureList: action.payload.data,
                totalItems: action.payload.total
            };
        case GET_PROPERTIES_DISCONTINUED_SUCCESS:
            return {
                ...state,
                discontinued: action.payload
            };
        default:
            return state;
    }    
};

export default ReportsReducer;